import { render, staticRenderFns } from "./userAndroidVersion.vue?vue&type=template&id=4c670553&scoped=true"
import script from "./userAndroidVersion.vue?vue&type=script&lang=js"
export * from "./userAndroidVersion.vue?vue&type=script&lang=js"
import style0 from "./userAndroidVersion.vue?vue&type=style&index=0&id=4c670553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c670553",
  null
  
)

export default component.exports